/* global dataLayer */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm, useWatch } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import { useRouter } from 'next/router';
import Fieldset from 'Components/Fieldset';
import Field from 'Components/Field';
import RadioButton from 'Components/RadioButton';
import ButtonNext from 'Components/ButtonNext';
import updateAction from 'utils/updateAction';
import s from './Step3.module.scss';

const Step3 = ({ formNamespace, gifts }) => {
    const router = useRouter();
    const updateName = (state, payload) => {
        return updateAction(state, payload, formNamespace);
    };
    const { state, actions } = useStateMachine({ updateName });
    const {
        register,
        handleSubmit,
        getValues,
        setValue,
        formState,
        watch,
        trigger,
        control,
    } = useForm({
        mode: 'onChange',
        defaultValues: state[formNamespace],
    });
    const { errors, isValid } = formState;

    const onSubmit = (data) => {
        if (!data.freeAmount) {
            Object.assign(data, { freeAmount: null });
        }

        const gift = JSON.parse(data.gift);

        dataLayer.push({
            event: 'checkoutSteps',
            eventCategory: 'hyllningsgåva',
            eventAction: 'belopp',
            eventLabel: parseInt(data.freeAmount || gift.price),
        });

        Object.assign(data, { steg3: true });
        actions.updateName(data);
        router.push({hash: 'steg4'});
    };

    useEffect(() => {
        trigger();

        const params = new URLSearchParams(window.location.search);
        if (!params.get('gift')) {
            return;
        }

        const giftId = parseInt(params.get('gift').replace('/', ''));
        const gift = gifts.find((item) => item.ID.toString() === giftId);

        setValue('giftChoice', gift.ID.toString());
        setValue('gift', JSON.stringify(gift));
        actions.updateName({ gift: getValues('gift') });
    }, []);

    const watchGift = useWatch({control, name: 'giftChoice'});

    useEffect(() => {
        const gift = gifts.find((item) => item.ID.toString() === watchGift);
        setValue('gift', JSON.stringify(gift));
    }, [watchGift]);

    const freeAmoutGift = gifts.find(({price}) => price === '0' || price === '1');
    const showFreeAmount = freeAmoutGift && freeAmoutGift.ID.toString() === watchGift;

    return (
        <form className={s['Step3']} onSubmit={handleSubmit(onSubmit)}>
            <Fieldset title="Jag vill ge">
                {gifts.map((item, index) => (
                    <RadioButton
                        key={`gift-${item.ID}`}
                        id={`gift-${item.ID}`}
                        label={item.value}
                        name="giftChoice"
                        register={register('giftChoice')}
                        value={item.ID.toString()}
                        checked={item.ID.toString() === watchGift}
                        fullWidth={true}
                    />
                ))}
                {showFreeAmount && (
                    <Field
                        key="free-amount"
                        name="freeAmount"
                        label="Ange ett belopp"
                        required={true}
                        register={register('freeAmount', {
                            required: 'Vänligen fyll i ett giltigt belopp',
                            pattern: {
                                value: /^[1-9][0-9]+$/,
                                message:
                                    'Vänligen fyll i ett giltigt belopp',
                            },
                            min: {value: 1, message: 'Minsta valfria beloppet är 1 kr'},
                        })}
                        errors={errors}
                    />
                )}
            </Fieldset>

            <ButtonNext disabled={!isValid}>Nästa steg</ButtonNext>
        </form>
    );
};

Step3.propTypes = {
    formNamespace: PropTypes.string,
    gifts: PropTypes.array,
};

Step3.defaultProps = {
    gifts: [],
};

export default Step3;
